package ui.screens

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import data.repository.FirebaseInvitationRepo
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.icon_not_invited

@Composable
fun NotInvitedScreen(
    onBack: () -> Unit = {},
    modifier: Modifier = Modifier,
) = BoxWithConstraints(modifier) {
    val repo = FirebaseInvitationRepo()
    val name = GreetingByPath()
    val nameInvited by repo.checkInvitationByName(name).collectAsState(initial = null)
    // Menyimpan nilai exists sebelumnya
    var prevExists by remember { mutableStateOf<Boolean?>(null) }

    LaunchedEffect(nameInvited) {
        nameInvited?.let { data ->
            val now = data.exists
            val before = prevExists

            // Update previous state
            prevExists = now

            // Redirect hanya jika:
            // sebelumnya FALSE, sekarang TRUE
            if (before == false && now == true) {
                println("AUTO RETURN to GATE (state changed false→true)")
                onBack()
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Brush.verticalGradient(
                    listOf(
                        Color(0xFF101010),
                        Color(0xFF303030)
                    )
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.padding(24.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // Gambar atau ikon sedih
            Image(
                painter = painterResource(Res.drawable.icon_not_invited),
                contentDescription = "Not invited",
                modifier = Modifier.size(120.dp)
            )

            Text(
                text = "Mohon Maaf",
                color = Color.White,
                fontSize = 28.sp,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(top = 16.dp)
            )

            Text(
                text = "Nama Anda tidak terdaftar dalam daftar undangan.\n" +
                        "Silakan hubungi pengundang untuk informasi lebih lanjut.",
                color = Color(0xFFDDDDDD),
                fontSize = 16.sp,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(vertical = 12.dp)
            )
        }
    }
}